export default {"src":"/_next/static/media/flow-3.18844d17.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};